<template>
    <section>
        <header class="f fh c-p dw-10 sp-t-xs sp-b-xs" @click="collapsed = !collapsed">
            <VisualSectionTitle :icon="icon"
                :iconSize="iconSize"
                :iconCname="iconCname"
                :name="uiTitle">
                <template #labelRight v-if="uiCount && uiCount > 0"><small class="el-badge sm-l-xs">{{ uiCount }}</small></template>
            </VisualSectionTitle>
            <span class="fg"></span>
            <CollapseTrigger v-model="collapsed" />
        </header>
        <div v-if="!collapsed">
            <slot name="body"></slot>
        </div>
        <div v-if="collapsed">
            <slot name="bodyCollapsed"></slot>
        </div>
    </section>
</template>

<script>
import VisualSectionTitle from './visuals/SectionTitle.vue';
import CollapseTrigger from './CollapseTrigger.vue';

export default {
    name: 'mead-collapsible',
    props: {
        /**
         * Name of the icon shown in the section title, passed through to
         * `VisualSectionTitle`.
         */
        icon            : {type: [Boolean, String], default: () => false},
        /**
         * Additional class name applied to the title icon, passed through to
         * `VisualSectionTitle`.
         */
        iconCname       : {type: String, default: () => ''},
        /**
         * Size of the title icon, passed through to `VisualSectionTitle`.
         */
        iconSize        : {type: String, default: () => 'l'},
        /**
         * Title text shown in the header, passed through to `VisualSectionTitle`
         * as its `name`.
         */
        uiTitle         : {type: [Boolean, String], default: () => false},
        /**
         * Optional numeric badge shown next to the title when greater than 0.
         */
        uiCount         : {type: [Boolean, Number], default: () => false},
        /**
         * Initial collapsed state of the section body when the component mounts.
         */
        uiCollapsed     : {type: Boolean, default: () => false},
    },
    components: {VisualSectionTitle, CollapseTrigger},
    data () {
        return {
            collapsed: this.uiCollapsed,
        };
    },
};
</script>
<style lang="scss" scoped>
@use '../../../sass/variables' as *;
</style>
